import React from 'react';
import classNames from 'classnames';
import {Button as ButtonSyled} from './styles'

export const Button = ({ children, small = false, ...props }) => (
  <ButtonSyled className={classNames({ small })} {...props}>
    {children}
  </ButtonSyled>
)

export default Button;

